/*
  orlea-swiper-stub.js — Faux Swiper minimal.
  On a retire la vraie librairie Swiper (152 Ko) du theme, mais critical.js
  (Flaunt) fait `new Swiper(...)` dans plusieurs custom elements (ProductCard,
  CartDrawer, HeaderSearch, ProductMobileMedia...). Sans Swiper defini ->
  ReferenceError. Ce stub fournit juste ce que critical.js appelle reellement,
  verifie par recensement exhaustif :
    - constructeur : attache el.swiper = this ; expose .slides (vrais slides) ;
      .allowTouchMove inscriptible ; ignore les options.
    - 3 methodes no-op : slideTo, update, destroy.
    - 2 statiques : use, Navigation.
  Aucune section qui utilise VRAIMENT un carrousel Swiper n'est active sur nos
  pages (barre d'annonce, galerie PDP = recodees maison ; recherche/upsell =
  inactifs). Les cartes produit (ProductCard) gardent leur `.slides` reel pour
  ne pas casser le changement d'image au clic de teinte.
  DOIT etre charge AVANT critical.js.
*/
(function () {
  'use strict';
  if (window.Swiper) return;

  function Swiper(el, opts) {
    if (el) { try { el.swiper = this; } catch (e) {} }
    this.el = el || null;
    this.slides = el && el.querySelectorAll ? el.querySelectorAll('.swiper-slide') : [];
    this.allowTouchMove = true;
    this.params = opts || {};
  }

  Swiper.prototype.slideTo = function () {};
  Swiper.prototype.slideToLoop = function () {};
  Swiper.prototype.update = function () {};
  Swiper.prototype.destroy = function () {
    if (this.el) { try { this.el.swiper = null; } catch (e) {} }
  };
  Swiper.prototype.on = function () {};
  Swiper.prototype.off = function () {};

  Swiper.use = function () {};
  Swiper.Navigation = {};
  Swiper.Thumbs = {};
  Swiper.Autoplay = {};

  window.Swiper = Swiper;
})();
